import React, {Component, PropTypes} from 'react'
import cx from 'classnames'

export function redirect(to) {
	const selectPathname = (typeof to == 'function') && to || (() => to)

	return (nextState, replaceState) => {
		const {location} = nextState
		const pathnameSegments = location.pathname.split('/').slice(1)

		var replacePathname = selectPathname()
		replacePathname = replacePathname.replace(/^\/\*\//, '/' + pathnameSegments[0] + '/')
		replacePathname = replacePathname.replace(/^(\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[1] + '/')
		replacePathname = replacePathname.replace(/^(\/[\w-]+\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[2] + '/')
		replaceState({pathname: replacePathname})
	}
}

export function after(onEnter) {
    return (nextState, replaceState) => {
        setTimeout(() => {
            onEnter(nextState, replaceState, () => {})  
        }, 0)
    }
}


function pathBuilder(result, route) {
    const path = route.path
    const pathTokens = path && path.split('/').filter((t) => !!t) || []

    result.push(...pathTokens)
    return result
}

class Breadcrumb extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        routes: PropTypes.array.isRequired,
        params: PropTypes.array.isRequired,
        display: PropTypes.func,
        disable: PropTypes.func   
    }

    static defaultProps = {
        display: (v) => v,
        disable: (v) => false
    }

    constructor(props) {
        super(props)

        this.state = {
            path: []
        }
    }

    componentWillMount() {
        const {routes} = this.props

        const path = routes.reduce(pathBuilder, [])
        this.setState({path})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.routes != this.props.routes) {
            const {routes} = nextProps

            const path = routes.reduce(pathBuilder, [])
            this.setState({path})
        }
    }

    _navigate(event, path) {
        const {history, params} = this.props
        const locationPathname = '/' + path.map((t) => params[t.slice(1)] || t).join('/')

        event.preventDefault()
        history.push(locationPathname)
    }

    render() {
        const {display, disable} = this.props
        const {path} = this.state

        const isActive = (index) => {
            return index == path.length - 1
        }

        return (
            <ol className='breadcrumb'>
                {path.map((token, index) => (
                    <li
                        key={index}
                        className={cx({active: isActive(index)})}>
                        {(isActive(index) || disable(token)) && display(token) || (
                            <a
                                href=''
                                onClick={(e) => this._navigate(e, path.slice(0, index + 1))}>
                                {display(token)}
                            </a>
                        )}
                    </li>
                ))}
            </ol>
        )
    }
}

export {Breadcrumb}


// WEBPACK FOOTER //
// ./lib/core/react/router.js